<template>
  <BModal
    id="modal-withdrawal"
    no-stacking
    centered
    hide-footer
    hide-header
    hide-header-close
    no-close-on-backdrop
    no-close-on-esc
    size="md"
  >
    <BRow class="justify-center my-1 flex flex-column">
      <BCol class="d-flex justify-content-center">
        <strong class="text-black text-xl">
          Penarikan Saldo Komcards
        </strong>
      </BCol>
      <BCol class="d-flex justify-content-center my-1">
        <div class="text-black text-md">
          Saldo Komcards yang kamu tarik akan masuk ke saldo Kompay
        </div>
      </BCol>
      <BCol class="justify-content-center">
        <ValidationObserver #default="{ invalid }">
          <BFormGroup>
            <template #label>
              <div class="flex justify-between">
                <div class="text-black flex items-center">
                  <strong class="text-md font-semibold">Nominal</strong>
                  <strong class="text-primary">*</strong>
                </div>
              </div>
            </template>
            <ValidationProvider
              #default="{ errors }"
              name="Nominal"
              :rules="{
                required: true,
                minAmountWithdrawal: { min: 10000 },
                maxAmountWithdrawal: { max: balance.effective_balance }
              }"
            >
              <BFormInput
                v-model="nominal"
                :placeholder="'Minimal Rp. 10.000'"
                :state="errors.length > 0 ? false : null"
                @keypress="isNumber($event)"
                @input="formatCurrency"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </ValidationProvider>
            <BCol
              class="border rounded-lg p-1 my-2"
              style="border-color: #E2E2E2 !important"
            >
              <BPopover
                triggers="hover"
                target="popover-saldo-pending"
                placement="topRight"
              >
                Saldo ini belum dapat ditarik, namun bisa digunakan untuk
                transaksi. Pihak penyedia layanan segera memprosesnya kembali
                ke kartu debit kamu
              </BPopover>
              <div class="flex items-center justify-between font-semibold text-black ml-1">
                <div>Saldo Komcards</div>
                <div>{{ IDR(balance.real_balance, 2, 2) }}</div>
              </div>
              <div class="flex items-center justify-between  text-black ml-2">
                <div>Voucher Iklan</div>
                <div class="text-primary">
                  {{ IDR(balance.voucher_balance, 2, 2) }}
                </div>
              </div>
              <div class="flex items-center justify-between text-black ml-2">
                <div class="flex items-center gap-3">
                  <div>Saldo Pending</div>
                  <img
                    id="popover-saldo-pending"
                    src="https://storage.googleapis.com/komerce/assets/icons/info-circle.svg"
                    alt="Komerce"
                    width="20"
                    class="cursor-pointer"
                  >
                </div>
                <div class="text-primary">
                  {{ IDR(balance.hold_balance, 2, 2) }}
                </div>
              </div>
              <div class="flex items-center justify-between  text-black ml-2">
                <div>Saldo Mengendap</div>
                <div class="text-primary">
                  {{ IDR(balance.balance_settle, 2, 2) }}
                </div>
              </div>
              <div
                class="flex items-center justify-between font-semibold text-black mt-1 border-[#FEF2CD] bg-[#FFF8E1] rounded-lg p-1"
              >
                <div>Saldo yang bisa ditarik</div>
                <div class="font-semibold">
                  {{ IDR(balance.effective_balance, 2, 2) }}
                </div>
              </div>
            </BCol>
          </BFormGroup>
          <BCol class="flex flex-row gap-4 justify-center mt-1">
            <BButton
              variant="outline-primary"
              @click="onBack"
            >
              Kembali
            </BButton>
            <BButton
              :variant="invalid ? 'secondary' : 'primary'"
              type="submit"
              :disabled="invalid"
              @click="onUpdate"
            >
              Tarik Saldo
            </BButton>
          </BCol>
        </ValidationObserver>
      </BCol>
    </BRow>
  </BModal>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { IDR } from '@/libs/currency'
import { isNumber } from '@/libs/helpers'
import isNaN from 'lodash/isNaN'
import { required } from '@validations'
import { newAxiosIns } from '@/libs/axios'

extend('minAmountWithdrawal', {
  params: ['min'],
  message: (_, values) => `Minimal penarikan adalah ${IDR(values.min)}`,
  validate(value, { min }) {
    const numericValue = parseInt(value.toString().replace(/\D/g, ''), 10)
    return numericValue >= min
  },
})

extend('maxAmountWithdrawal', {
  params: ['max'],
  message: (_, values) => `Maksimal penarikan adalah ${IDR(values.max)}`,
  validate(value, { max }) {
    const numericValue = parseInt(value.toString().replace(/\D/g, ''), 10)
    return numericValue <= max
  },
})

export default {
  components: { ValidationObserver, ValidationProvider },
  props: {
    balance: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isNumber,
      required,
      IDR,
      nominal: '',
    }
  },
  methods: {
    onUpdate() {
      this.$bvModal.show('modal-verify-pin')
      this.$bvModal.hide('modal-withdrawal')
      this.updateInput()
      // await newAxiosIns.get('/auth/api/v1/user/secured/verify-pin/attempt-left')
      //   .then(response => {
      //     const { data } = response.data
      //     if (data.attempt_left === 0) {
      //       this.$bvModal.show('max-chance-PIN')
      //       this.$bvModal.hide('modal-withdrawal')
      //     } else {
      //       this.$bvModal.show('modal-verify-pin')
      //       this.$bvModal.hide('modal-withdrawal')
      //       this.updateInput()
      //     }
      //   }).catch(() => {
      //     this.$toast_error({ message: 'Gagal cek PIN, silahkan refresh page' })
      //   })
    },
    updateInput() {
      this.$emit('update-nominal-withdrawal', this.nominal)
    },
    formatCurrency(value) {
      const newValue = Number(value.replace(/\D/g, ''))
      this.nominal = isNaN(newValue) ? value : IDR(newValue)
    },
    onBack() {
      this.$bvModal.hide('modal-withdrawal')
      this.nominal = ''
    },
    onReset() {
      this.nominal = ''
    },
  },
}
</script>
